import { Legend_Config, Tooltip_Config, AxisConfig, SeriesLineStyle } from '@blade-sxp/portrait-center/utils/common-chart-config';
import { Scale } from '@blade/common/utils/auto-scale';
import { merge } from 'lodash';
import colors from '@/styles/color.scss';
const echarts = require('echarts');
const flowEchartConfig = (vue) => {
    return {
        tooltip: {
            trigger: 'axis',
            ...Tooltip_Config,
        },
        legend: {
            left: 0,
            data: [
                { name: vue.$t('male'), textStyle: { color: colors.portraitCenterBarhConfigSeries } },
                { name: vue.$t('female'), textStyle: { color: colors.portraitCenterBarhConfigSeriesAdult } }
            ],
            ...Legend_Config
        },
        color: [colors.portraitCenterBarhConfigSeries, colors.portraitCenterBarhConfigSeriesAdult],
        grid: {
            left: 0,
            bottom: 20 * Scale,
            top: 45 * Scale,
            right: 0,
            containLabel: true,
        },
        dataZoom: [
            {
                type: 'inside',
                start: 0,
                minSpan: 1,
                end: 100
            },
            {
                type: 'slider',
                start: 0,
                end: 100,
                handleIcon: 'M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z',
                handleSize: 9 * Scale,
                handleStyle: {
                    color: colors.white,
                    borderWidth: 3 * Scale,
                    borderColor: colors.portraitEchartBorder
                },
                backgroundColor: colors.portraitCenterCchartZoom,
                borderColor: 'none',
                height: 4 * Scale,
                left: 8 * Scale,
                right: 8 * Scale,
                bottom: 6 * Scale,
                fillerColor: colors.portraitEchartBorder,
                showDetail: false,
                showDataShadow: false,
                filterMode: 'empty',
                brushSelect: false, // 是否开启刷选功能,默认true
            },
        ],
        xAxis: {
            type: 'category',
            data: [],
            ...merge({}, AxisConfig, {
                axisLabel: {
                    interval: 'auto',
                    align: 'center',
                    formatter: (label) => label.slice(5),
                }
            }),
        },
        yAxis: {
            type: 'value',
            ...merge({}, AxisConfig, {
                splitNumber: 2,
            }),
            axisLine: {
                show: false,
            },
        },
        series: [
            {
                name: vue.$t('male'),
                type: 'line',
                stack: vue.$t('male'),
                data: [],
                ...SeriesLineStyle,
                // itemStyle: BlueItemStyle,
            },
            {
                name: vue.$t('female'),
                type: 'line',
                stack: vue.$t('female'),
                data: [],
                ...SeriesLineStyle,
                // itemStyle: {
                //   normal: {
                //     areaStyle: {
                //       color: new echarts.graphic.LinearGradient(0, 0, 0, 0.8, // 变化度
                //         [{
                //           offset: 0,
                //           color: colors.echartlineservice4,
                //         },
                //         {
                //           offset: 0.3,
                //           color: colors.echartlineservice5,
                //         },
                //         {
                //           offset: 1,
                //           color: colors.echartlineservice6,
                //         }]),
                //     }
                //   }
                // }
            },
        ],
    };
};
export default flowEchartConfig;
